import request from '@/utils/request'
//get
export function getModuleAuthParam(param) {
  return request({
    url: `/module_pack/${param}`,
    method: 'GET'
  })
}
export function getModule() {
  return request({
    url: `/module/`,
    method: 'GET'
  })
}

export function getModulePack() {

  return request({
    url: `/module/resource_list/`,
    method: 'GET'
  })
}

export function buyPrice(data) {
  return request({
    url: `/module_pack/buy_price/`,
    method: 'POST',
    data
  })
}

export function buy(data) {
  return request({
    url: `/module_pack/buy/`,
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/modulePack.js